import { call, put, takeLatest } from "redux-saga/effects"

// action
import {
    SAVE_APPOINTMENT_REPORT,
    saveAppointmentReportFail,
    saveAppointmentReportSuccess
} from '../action/saveAppointmentReportAction'

// api 
import saveAppointmentReportApi from '../api/saveAppointmentReportApi'

export function* saveAppointmentReportSaga(action) {
    try {
        const response = yield call(() => saveAppointmentReportApi(action.params))
        if (response.data.status === 1) {
            yield put(saveAppointmentReportSuccess(response, action))
        } else {
            yield put(saveAppointmentReportFail(response, action))
        }
    }
    catch (e) {
        yield put(saveAppointmentReportFail(e.response, action))
    }

}

export default function* mySaga() {
    yield takeLatest(SAVE_APPOINTMENT_REPORT, saveAppointmentReportSaga)
}